import { DriverTableDTO } from '../../../../../Domain/DTO/DriverTableDTO';

export class SelectDriverDTO{
    SelectedDriver: DriverTableDTO;
    SelectedDriverIds: Array<string>;
}